import { useNavigate } from 'react-router-dom';

import { removeStorageRecord } from '../api';

import useUserAuth from './useUserAuth';
import useGlobalStatus from './useGlobalStatus';
import { PAGE } from '../constants/url';

import {
  ALERT_TYPE,
  ERROR_CERTIFICATE,
  ERROR_SYSTEMCONNECT
} from '../constants/alertMsg';

const useApiError = () => {
  const navigate = useNavigate();
  const { setUserAuth, setAuthStatusMsg, setAlertMsg } = useUserAuth();
  const { handleAlertMsgSettings } = useGlobalStatus();

  const handleApiErrorStatus = (res) => {
    const result = res.data;

    if(result.status === 401) {
      removeStorageRecord();
      setUserAuth(null);
      setAuthStatusMsg(ERROR_CERTIFICATE);
      navigate(PAGE.LOGIN.path);
    } else {
      handleAlertMsgSettings(true, { type: ALERT_TYPE.ERROR, msg: ERROR_SYSTEMCONNECT });
    }
  }

  return { handleApiErrorStatus };
};

export default useApiError;